<div>

    <div class="col-md-10 mx-auto">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb small">
                <li class="breadcrumb-item"><a routerLink="/">Inicio</a></li>
                <li class="breadcrumb-item"><a routerLink="/cotizar">Cotizar</a></li>
                <li class="breadcrumb-item active">Vehículo Particular</li>
            </ol>
        </nav>
    </div>


    <div class="row no-gutters shadow">

        <div class="col-md-6">
            <div class="bgCotizacionPersonaNatural"></div>
        </div>

        <div class="col-md-6 px-3 px-md-6 py-3 py-md-5" *ngIf="cotizacion">

            <div class="">
                <p class="h2">Gracias {{cotizacion.datos.nombre}},</p>
                <p>Te mostramos el detalle de tu cotización. Además, te hemos enviado un correo electrónico con la cotización solicitada.</p>
            </div>

            <div class="border border-primary p-3 rounded-lg">
                <div class="d-flex justify-content-between">
                    <div class="mr-3">
                        <p class="h4 mb-0 text-secondary">Plan de Servicio {{cotizacion.plan.tipoPlan.nombre}} + GPS</p>
                        <p class="mb-0">Pago único por el equipo GPS. Incluye instalación.</p>
                    </div>
                    <div class="">
                        <p class="h4 mb-0 font-weight-bold text-secondary" style="white-space: nowrap;">US$ {{cotizacion.plan.tipoPlan.precio}}</p>
                    </div>
                </div>
            </div>

            <p class="text-center small text-muted mb-0">* Los precios no incluyen I.G.V.</p>
            <div class="text-center mt-3 mt-md-4">
                <a class="btn btn-primary btn-lg btn-block px-4" href="https://api.whatsapp.com/send?phone=51944579506&text=Hola me interesa el plan {{cotizacion.plan.tipoPlan.nombre}} de S/. {{cotizacion.plan.tipoPlan.precio}} para Empresa" target="blank">Contactar asesor</a>
            </div>


        </div>


    </div>

    <div class="col-md-10 mx-auto py-4 py-md-6">
        <p class="h5 text-center text-secondary">Mira todas las características</p>
        <app-beneficios-plan-persona-natural></app-beneficios-plan-persona-natural>
        <div class="col-md-7 mx-auto">
            <app-acreditados></app-acreditados>
        </div>
    </div>

</div>